import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-main-content" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "tip" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-gantanhaozhong" }),
  /*#__PURE__*/_createTextVNode(" 请下载模板之后输入对应的信息，可批量复制至模板内，若格式错误或超出企业人数上限将无法导入。 ")
], -1)
const _hoisted_3 = { class: "item download" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "left" }, "点击下载", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("b", { class: "iconfont icon-moban" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Excel模板 ")
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "item select-table" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "left" }, "选择表格", -1)
const _hoisted_10 = { class: "right" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("上传文件")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, [
  /*#__PURE__*/_createElementVNode("p", null, "仅支持.xls,.xlsx")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "部分员工信息导入失败，是否下载导入失败列表？")
], -1)
const _hoisted_14 = { class: "download-button" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("下载")

import { downloadByteArraystream } from "@ldos/shared-common/src/util/utilsHandle";
import { ApiOptions } from "@velites/api";
import { reactive, getCurrentInstance } from "vue";
interface IFormContent {
  id: string;
  name: string;
  code: string;
  status: number;
}

export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const { proxy } = getCurrentInstance() as any;
const state = reactive({
  dialog: false,
  errorDialog: false,
  erroeExcel: "",
  title: "提示",
  uploadAccept:
    "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
});

const active = (res: IFormContent) => {
  state.dialog = true;
};

const downloadImport = async () => {
  const requests: ApiOptions = {
    method: "post",
    url: "/mgr/userTenant/downLoadUserModelExcel",
    data: {},
    responseType: "blob",
  };
  const response = await proxy.$api.requestRaw(requests);
  console.log(response);
  if (response && response.status === 200) {
    downloadByteArraystream(response);
    proxy.$Message({
      type: "success",
      message: "下载成功",
    });
  } else {
    proxy.$Message({
      type: "error",
      message: "下载失败",
    });
  }
};

const httpRequestChange = async (opt: any) => {
  const formData = new FormData();
  formData.append("file", opt.file);
  const requests: ApiOptions = {
    method: "post",
    url: "/mgr/userTenant/batchImportUserExcel",
    data: formData,
    responseType: "blob",
  };
  const response = await proxy.$api.requestRaw(requests);

  if (response && response.status === 200 && response.data.size === 0) {
    state.dialog= false
    proxy.$Message({
      type: "success",
      message: "上传成功",
    });
    proxy.$emit("optionUploadExcelSuccess");
  }else if (response && response.status === 200 && response.data.size > 0){
    state.erroeExcel = response;
    state.errorDialog = true;
    proxy.$Message({
      type: "success",
      message: "上传成功",
    });
    proxy.$emit("optionUploadExcelSuccess");
  } else {
    proxy.$Message({
      type: "error",
      message: "上传失败",
    });
  }
};

const downloadErrorImport = () => {
  downloadByteArraystream(state.erroeExcel);
  state.errorDialog = false;
};
const confirm = () => {
  proxy.$Message({
    type: "success",
    message: "操作成功",
  });
  state.dialog = false;
};

expose({
  active,
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_mas_modal = _resolveComponent("mas-modal")!
  const _directive_perm = _resolveDirective("perm")!

  return (_openBlock(), _createBlock(_component_mas_modal, {
    visible: _unref(state).dialog,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).dialog) = $event)),
    closeIcon: "",
    width: "550px",
    footer: false,
    title: _unref(state).title,
    onConfirm: confirm
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", {
            class: "right",
            onClick: downloadImport
          }, _hoisted_7)
        ])), [
          [_directive_perm, 'Mgr.Config.Staff.Import.Download.button']
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_el_upload, {
              class: "upload-own",
              accept: _unref(state).uploadAccept,
              "http-request": httpRequestChange
            }, {
              tip: _withCtx(() => [
                _hoisted_12
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_button, { type: "primary" }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["accept"])
          ])
        ])), [
          [_directive_perm, 'Mgr.Config.Staff.Import.Upload.button']
        ])
      ]),
      _createVNode(_component_mas_modal, {
        visible: _unref(state).errorDialog,
        "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).errorDialog) = $event)),
        closeIcon: "",
        width: "450px",
        footer: false,
        title: _unref(state).title,
        onConfirm: confirm
      }, {
        content: _withCtx(() => [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: downloadErrorImport
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["visible", "title"])
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}
}

})